module.exports = __webpack_public_path__ + "static/media/info.4746e5ee.jpg";